module.exports = __webpack_public_path__ + "73bb61638ca19e139118858de40538fc.png";